import React, { useState, useEffect } from 'react';
import Helmet from 'react-helmet';
import Axios from 'axios';
import CountUp from 'react-countup';

import ClientItem from '../../components/ClientItem';
import { getVariable } from '../../utils/variableGetter';

import './index.scss';
import SNSPanel from '../../components/SNSPanel';

const ClientPage = ({ wording }) => {
  const [client, setClient] = useState(null);
  const [spaceQty, setSpaceQty] = useState(null);
  const [projectQty, setProjectQty] = useState(null);
  const [returnQty, setReturnQty] = useState(null);

  useEffect(() => {
    getQtyNumbers();
    getClient();
  }, []);

  const getQtyNumbers = () => {
    Axios.get(`/api/variable`).then(res => {
      const spaceQty = getVariable('client_space', res.data);
      const projectQty = getVariable('client_project', res.data);
      const returnQty = getVariable('client_return', res.data);
      setSpaceQty(spaceQty);
      setProjectQty(projectQty);
      setReturnQty(returnQty);
    });
  };

  const getClient = () => {
    Axios.get(`/api/client`).then(res => setClient(res.data));
  };

  const _w = wording;
  return (
    <React.Fragment>
      <Helmet>
        <title>{_w.meta_title}</title>
      </Helmet>
      <div className="client-page">
        <SNSPanel />
        <div className="client-topic">
          <div className="container">
            <div className="topic inner-container">
              <div className="title">
                <h1 className="type-heading -en -h2">
                  <span>{_w.heading}&nbsp;</span>
                  <span className="highlight">{_w.heading_color}</span>
                </h1>
              </div>
              <div className="illustration">
                <div className="item client-box">
                  <img className="box" src="/images/client-box.svg" alt="" />
                  <div className="content">
                    <img className="draw" src="/images/client-icon-1.svg" alt="" />
                    <CountUp className="qty type-heading -en -h2" end={Number(spaceQty)} duration={4} />
                    <div className="label type-text -ch -lg">{_w.space}</div>
                  </div>
                </div>
                <div className="item client-box">
                  <img className="box" src="/images/client-box.svg" alt="" />
                  <div className="content">
                    <img className="draw" src="/images/client-icon-2.svg" alt="" />
                    <CountUp className="qty type-heading -en -h2" end={Number(projectQty)} duration={4} />
                    <div className="label type-text -ch -lg">{_w.project}</div>
                  </div>
                </div>
                <div className="item client-box">
                  <img className="box" src="/images/client-box.svg" alt="" />
                  <div className="content">
                    <img className="draw" src="/images/client-icon-3.svg" alt="" />
                    <div className="qty">
                      <CountUp className="type-heading -en -h2" end={Number(returnQty)} duration={4} />
                      <span className="type-heading -en -h2">%</span>
                    </div>
                    <div className="label type-text -ch -lg">{_w.repurchase}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="client-list">
          <div className="container">
            <div className="inner-container">
              <div className="heading">
                <div className="title type-heading -en -h2">{_w.title}</div>
                <div className="description type-heading -en -h5">{_w.description}</div>
              </div>
              <div className="client-grid">
                {
                  client && client.map((item, i) =>
                    <div className="item" key={i}>
                      <ClientItem photo={`/${item.photo}`} title={item.title} link={item.link} />
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ClientPage;